import MenuEngineering from './MenuEngineering.vue';
import MenuRecommendation from './views/MenuRecommendation.vue';
import MenuRecommendationDetail from './views/MenuRecommendationDetail.vue';
import MenuRecommendationList from './views/MenuRecommendationList.vue';

export const menuEngineeringRoutes = [
  {
    path: 'menu-engineering',
    component: MenuEngineering,
    children: [
      { path: '', component: MenuRecommendationList, name: 'menu-recommendation-list' },
      { path: ':menuRecommendationGuid', component: MenuRecommendation, name: 'menu-recommendation' },
      {
        path: ':menuRecommendationGuid/detail',
        component: MenuRecommendationDetail,
        name: 'menu-recommendation-detail',
        props: true
      }
    ]
  }
];
